/* Stock badge - BrewTaurus. Follows the selected variant. */
(function () {
  'use strict';
  if (customElements.get('stock-badge')) return;

  class StockBadge extends HTMLElement {
    connectedCallback() {
      if (this.dataset.fixed) return;
      try {
        var el = this.querySelector('[data-role="qty-map"]');
        this.map = el ? JSON.parse(el.textContent) : {};
      } catch (e) { this.map = {}; }
      this.content = this.querySelector('[data-role="content"]');
      this.form = this.findForm();
      var self = this;
      var refresh = function () { setTimeout(function () { self.render(); }, 150); };
      var section = this.closest('.shopify-section') || document;
      section.addEventListener('change', refresh);
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        try { window.subscribe(window.PUB_SUB_EVENTS.variantChange, refresh); } catch (e) { /* noop */ }
      }
      this.render();
    }
    findForm() {
      var sid = this.dataset.sectionId;
      var section = this.closest('.shopify-section') || document;
      return (
        (sid && document.getElementById('product-form-' + sid)) ||
        section.querySelector('form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]')
      );
    }
    render() {
      if (!this.content) return;
      var id = null;
      if (this.form) {
        var input = this.form.querySelector('[name="id"]');
        if (input) id = input.value;
      }
      if (!id || !(id in this.map)) {
        var keys = Object.keys(this.map);
        if (keys.length === 1) id = keys[0];
      }
      var entry = id != null ? this.map[id] : undefined;
      if (entry === undefined) { this.content.innerHTML = ''; return; }
      var q = entry[0];
      var avail = entry[1] === 1;
      var cls, text;
      if (q === null) { cls = 'in'; text = 'In stock'; }
      else if (q >= 5) { cls = 'in'; text = 'In stock — 5+ ready to ship'; }
      else if (q > 0) { cls = 'low'; text = 'Only ' + q + ' left in stock'; }
      else if (avail) { cls = 'in'; text = 'In stock'; }
      else { cls = 'out'; text = 'Out of stock'; }
      this.content.innerHTML =
        '<span class="stock-badge__dot stock-badge__dot--' + cls + '"></span>' +
        '<span class="stock-badge__text stock-badge__text--' + cls + '">' + text + '</span>';
    }
  }
  customElements.define('stock-badge', StockBadge);
})();
